/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import { memo } from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import PropTypes from 'prop-types';

const optionsBodyBig = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node, children) => (
			<p className="typography typography--tertiary typography--body-big">
				{children}
			</p>
		),
		[INLINES.HYPERLINK]: ({ data }, children) => (
			<a href={data.uri} target="_blank" rel="noopener noreferrer">
				{children}
			</a>
		),
	},
};

const _ExploreTesting = ({
	title,
	columns,
	sectionClassName = '',
	contentClassName = '',
}) => {
	return (
		<div className={`section explore-testing ${sectionClassName}`}>
			<div className={`section__content ${contentClassName}`}>
				<h2 className="typography typography--secondary typography--h2">
					{title}
				</h2>
				<div className="explore-testing__items">
					{columns.map((option) => (
						<div className="explore-testing__items-item" key={option.title}>
							<h3 className="typography typography--secondary typography--h3">
								{option.title}
							</h3>
							<div>
								{renderRichText(option.description, optionsBodyBig)}
							</div>
							{option.cta && (
								<Link to={option.cta.link}>
									<button className="btn btn--outlined">
										{option.cta.title}
									</button>
								</Link>
							)}
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

_ExploreTesting.propTypes = {
	columns: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			description: PropTypes.object.isRequired,
			cta: PropTypes.shape({
				title: PropTypes.string.isRequired,
				link: PropTypes.string,
			}),
		})
	).isRequired,
	sectionClassName: PropTypes.string,
	contentClassName: PropTypes.string,
	title: PropTypes.string.isRequired,
};

_ExploreTesting.defaultProps = {
	columns: [],
	title: '',
};

const ExploreTesting = memo(_ExploreTesting);

export default ExploreTesting;
